module.exports = __webpack_public_path__ + "img/ekool-logo.c94f3f5f.svg";